module.exports = __webpack_public_path__ + "media/images/emblems/Bonstetten-blazon-5575829f0ddba3026d4e59dc182b0e4b.svg";